// 🚨 關鍵修復：嚴格遵守 NCB 代理設定，絕對不可直接連線 app.nocodebackend.com
const NCB_CONFIG = {
  conversationId: 'chat-52bd1fcf-9baa-4f65-825e-1465dfdd1337',
  proxyBase: 'https://rmvzorxcl35mttidiexhtp5g2m0hpsqo.lambda-url.us-east-2.on.aws',
  instance: '55538_days_matter',
};

// 安全地串接 Proxy URL 並自動帶上 Instance 參數
function buildProxyUrl(path) {
  const url = new URL(path, NCB_CONFIG.proxyBase);
  if (NCB_CONFIG.instance) {
    url.searchParams.set('Instance', NCB_CONFIG.instance);
  }
  return url.toString();
}

const handleUnauthorized = (response) => {
  if (response.status === 401) {
    localStorage.removeItem('dm_current_user');
    localStorage.removeItem('user_id');
    window.dispatchEvent(new Event('auth-expired'));
  }
};

// 統一的請求處理器：回傳標準化信封 { status, data, metadata } 或 { status: 'error', error }
async function ncbRequest(url, options = {}) {
  try {
    const response = await fetch(url, {
      ...options,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    let body;
    try { body = await response.json(); } catch { body = {}; }

    if (!response.ok) {
      handleUnauthorized(response);
      return { status: 'error', data: null, error: body?.message || body?.error?.message || body?.error || `HTTP ${response.status}`, httpStatus: response.status };
    }

    // Data 端點回傳 { status, data, metadata } — 直接回傳
    if (body && typeof body === 'object' && !Array.isArray(body) && typeof body.status === 'string' && 'data' in body) {
      return body;
    }
    // Auth 端點回傳扁平物件 — 包裝為信封
    return { status: 'success', data: body };
  } catch (err) {
    return { status: 'error', data: null, error: err?.message || 'Network error' };
  }
}

// === 認證 API ===
export const ncbAuthClient = async (endpoint, options = {}) => {
  const path = endpoint.startsWith('/') ? `/auth${endpoint}` : `/auth/${endpoint}`;
  const url = new URL(buildProxyUrl(path));

  if (!options.method || options.method === 'GET') {
    url.searchParams.append('t', Date.now().toString());
  }

  const result = await ncbRequest(url.toString(), options);

  // Auth 失敗時拋出錯誤（保持 authAdapter 向後相容）
  if (result.status === 'error') {
    const message = result.httpStatus >= 500
      ? '登入服務目前發生後台錯誤，請稍後再試。'
      : result.error || 'Auth API Request Failed';
    const error = new Error(message);
    error.httpStatus = result.httpStatus;
    error.serverMessage = result.error;
    throw error;
  }
  return result.data;
};

// === 私人/共享資料 API (需要 session) ===
// 🚨 countdowns 表有 shared_readwrite 政策，必須走這條路由！
export const ncbDataClient = async (endpoint, options = {}) => {
  const path = endpoint.startsWith('/') ? `/data${endpoint}` : `/data/${endpoint}`;
  const url = buildProxyUrl(path);
  return ncbRequest(url, options);
};

// === 公開資料 API (不需要 session) ===
export const ncbPublicDataClient = async (endpoint, options = {}, ownerId = null) => {
  const path = endpoint.startsWith('/') ? `/public-data${endpoint}` : `/public-data/${endpoint}`;
  const url = new URL(buildProxyUrl(path));

  if (ownerId) {
    url.searchParams.set('owner_id', ownerId);
  }

  return ncbRequest(url.toString(), options);
};

export const authFetch = async (path, options = {}) => {
  const endpoint = path.startsWith('/') ? path : `/${path}`;
  const data = await ncbAuthClient(endpoint, options);
  return { status: 'success', data };
};

export const dataFetch = async (path, options = {}) => {
  const endpoint = path.startsWith('/') ? path : `/${path}`;
  return ncbDataClient(endpoint, options);
};

export const publicDataFetch = async (path, options = {}) => {
  const endpoint = path.startsWith('/') ? path : `/${path}`;
  return ncbPublicDataClient(endpoint, options);
};

export const ncbClient = ncbDataClient;